module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAA0BAMAAAAZEydKAAAAHlBMVEUAAAD/th7/th7/th7/th7/th7/th7/th7/th7/th5+bZkrAAAACXRSTlMA5sZlOhoGm5qT+MH6AAAAaUlEQVQoz+3MsQmAMBQA0QNxCBewdg07Z3ALR7AUhOC2Fv8fmOAIufKKx9PURx8/oxzNmPd6XNs4VeOGtRoLDN9RAM4YQQIES5AAwZIkJEuSkCySskjKIimLpCySskjKIimLpCySskjKvsQykiSUQJOoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan/tag.png
// module id = Ykar
// module chunks = 1